// extracted by mini-css-extract-plugin
export default {"wrapper":"PageTitle_wrapper__1ZvwK","title":"PageTitle_title__VaMvi","link":"PageTitle_link__X-H3O"};